/**
 * Steht dieser Artikel schon in Plenty? Die Umrechnung auf EIN Vokabular.
 *
 * 🔴 **Warum es diese Datei gibt (Bug vom 22.09.2026).** Vorschau und Entwurf führen
 * beide ein Feld namens `status` — mit verschiedenen Bedeutungen:
 *
 * | Herkunft | Feld | Werte |
 * |---|---|---|
 * | Vorschau (`artikel-vorschau`) | `existenz.status` | `neu` · `existiert` · `ungeprueft` |
 * | Entwurf (`artikelimport_zeile`) | `status` | `bereit` · `uebersprungen` · `fehler` |
 *
 * Die Entwurfsseite reichte ihren Zeilenzustand an die Vorsortierung durch, die den
 * Existenzbefund erwartet. `bereit` passte auf keine Gruppe, also zeigte die
 * Filterleiste **„Anlegen 0 · Unklar 88"** — obwohl genau diese 88 die anlegbaren
 * Artikel waren. Die Zahl stand groß über einer Liste, in der alles richtig war.
 *
 * Die alten Tests waren grün, weil sie dasselbe falsche Vokabular annahmen
 * (`artikel('jacke', 'uebersprungen')` als Existenzwert) — ein Test, der die Annahme
 * des Codes wiederholt, prüft nichts.
 */

import type { ExistenzBefund } from '../components/Vorsortierung';

/** Nur das, was für den Befund gebraucht wird — Entwurfszeile wie Vorschauzeile. */
export interface MitExistenz {
  status?: string;
  berechnet?: Record<string, unknown> | null;
}

/**
 * Der Existenzbefund einer Entwurfszeile. Pure.
 *
 * Er steht in `berechnet.existenzStatus`, das der Lauf beim Rechnen gesetzt hat.
 * Fehlt er (Entwürfe aus sehr frühen Ständen), wird **nicht geraten**: nur
 * „uebersprungen" ist eine sichere Aussage, alles andere gilt als ungeprüft. Ein
 * falsches „neu" wäre die teure Richtung — es lockt zum Anlegen eines Artikels, den
 * es schon gibt.
 */
export function existenzBefund(artikel: MitExistenz): ExistenzBefund {
  const ausBerechnung = (artikel.berechnet as { existenzStatus?: string } | null)
    ?.existenzStatus;
  if (ausBerechnung === 'neu' || ausBerechnung === 'existiert' || ausBerechnung === 'ungeprueft') {
    return ausBerechnung;
  }
  return artikel.status === 'uebersprungen' ? 'existiert' : 'ungeprueft';
}
